import { NBSP } from 'shared/constants/symbols';
import { IFourthUtpBlock } from 'shared/types/utp';

export const UTP: IFourthUtpBlock[] = [
  {
    title: { value: `Входит в топ-5 крупнейших игроков на${NBSP}российском рынке${NBSP}`, isBold: true },
  },
  {
    title: { value: 'Доступное продвижение через дополнительные инструменты' },
  },
  {
    title: {
      value: `Все категории хостов (хозяев): от частных владельцев до крупных управляющих компаний. Наша основная выручка — от профи рынка `,
    },
  },
  {
    title: {
      value: `Единая инфраструктура: календари занятости, чат с гостями, страховка имущества, поддержка в спорах`,
    },
  },
];
